/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const InnerBox = styled.div`
  padding: 6px 16px;
  display: flex;
  align-items: center;
  gap: 16px;
  text-decoration: none;
  color: inherit;
  height: 100%;
  width: 100%;
`;

export const ItemContainer = styled.li`
  list-style-type: none;
  cursor: pointer;
  width: ${({ width }) => (width ? `${width}px` : `100%`)};
  height: ${({ height }) => (height ? `${height}px` : `100%`)};
  min-width: 120px;
  text-align: left;
  border-radius: 4px;
  display: flex;
  align-items: center;
  border: 1px solid transparent;
  p {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
  }
  ${({ disabled, isSelected, isDestructive }) =>
    disabled
      ? css`
          cursor: not-allowed;
          opacity: 0.5;
          svg {
            fill: ${Palette.PrimaryGray._400};
          }
        `
      : css`
          color: ${isSelected ? Palette.Primary._500 : Palette.PrimaryGray._700};
          background: ${isSelected ? Palette.Primary._000 : 'inherit'};
          border: ${isSelected && `1px solid ${Palette.Primary._300}`};

          svg {
            fill: ${isSelected ? Palette.Primary._500 : Palette.PrimaryGray._400};
            width: 16px;
            height: 16px;
          }
          :hover {
            border-radius: 4px;
            background: ${Palette.PrimaryGray._100};
            color: ${isDestructive ? Palette.Red._500 : Palette.PrimaryGray._900};
            svg {
              fill: ${isDestructive ? Palette.Red._500 : Palette.Primary._500};
            }
          }
          :active {
            background: inherit;
            color: ${Palette.PrimaryGray._500};
            svg {
              fill: ${Palette.Primary._400};
            }
          }
        `}
`;

export const IconWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
